import algoliasearch from "algoliasearch"
import autocomplete from "autocomplete.js"
import { Controller } from "stimulus"

const client = algoliasearch("32OFKS54G6", "d1b54ad44b01012ff167435dae6fe2a5")
const index = client.initIndex(`Practice_${process.env.NODE_ENV}`)

export default class extends Controller {
  static targets = ["autocompleteSelections", "filterSelections", "allFilters", "locationField", "insuranceSelector"]

  connect() {
    this.setupSpecialtySearch()
  }

  // autocomplete.js (v0.38) is not compatible with the latest version algoliasearch v4 out of the box,
  // this next function create a compatible source that we can use in autocomplete()
  newHitsSource = (index, params) =>
    function doSearch(query, cb) {
      index
        .search(query, params)
        .then(function (res) {
          cb(res.hits, res)
        })
        .catch(function (err) {
          console.error(err)
          cb([])
        })
    }

  setupSpecialtySearch = () => {
    autocomplete(
      "#search_practitioner",
      {
        hint: false,
        clearOnSelected: true
      },
      [
        {
          source: this.newHitsSource(index, { hitsPerPage: 10 }),
          name: "Practitioners",
          displayKey: "user.name",
          templates: {
            header: function () {
              return "<span class='header'>Practitioners</span>"
            },
            empty: function () {
              return "<span class='no-results'>No practitioners found.</span>"
            },
            suggestion: function (suggestion) {
              return suggestion._highlightResult.user.name.value
            }
          }
        }
      ]
    ).on("autocomplete:selected", function (event, suggestion) {
      if (suggestion.user && suggestion.user.slug) {
        window.location.href = `/${suggestion.user.slug}`
      }
    })
  }

  preventSubmit = (event) => {
    event.preventDefault()
    return false
  }
}
